const ITEMS = [
  "Industrial Automation",
  "Switchgear",
  "Lighting",
  "Pneumatic Products",
  "Electrical Products",
  "Industrial Tools",
  "Multispan Controllers",
  "Crompton Lighting",
  "DeWalt Tools",
];

export default function Marquee() {
  const row = (
    <>
      {ITEMS.map((item) => (
        <span key={item} className="flex shrink-0 items-center gap-8 pr-8">
          <span className="font-heading text-lg font-semibold uppercase tracking-[0.18em] text-[#F6F7F8]">
            {item}
          </span>
          <svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">
            <path d="M7 0l2 5 5 2-5 2-2 5-2-5-5-2 5-2z" fill="#F5B700" />
          </svg>
        </span>
      ))}
    </>
  );
  return (
    <div
      className="relative overflow-hidden border-y border-[#2c2c2e] bg-[#111111] py-4"
      aria-hidden="true"
      data-testid="product-marquee"
    >
      <div className="animate-marquee flex w-max">
        <div className="flex">{row}</div>
        <div className="flex">{row}</div>
      </div>
    </div>
  );
}
